import CRFQPage from './ContractRFQ';

export default CRFQPage;



// WEBPACK FOOTER //
// ./src/pages/contractRFQ/index.jsx